import { Attributes, System, SystemQueries } from "ecsy";
import { MassData } from "../DataComponents/MassData";
import { RotationData } from "../DataComponents/RotationData";
import { TransformData } from "../DataComponents/TransformData";
import { VelocityData } from "../DataComponents/VelocityData";
import { BallTag } from "../TagComponents/BallTag";
import { FanTag } from "../TagComponents/FanTag";

export class FanPhysicsSystem extends System {
  static queries: SystemQueries = {
    balls: {
      components: [BallTag, TransformData, VelocityData, MassData],
    },
    fans: {
      components: [FanTag, TransformData, RotationData],
    },
  };

  init(attributes?: Attributes): void {}

  execute(delta: number, time: number): void {
    // Get all balls.
    const balls = this.queries.balls.results;
    // Get all fans.
    const fans = this.queries.fans.results;

    // For each ball...
    balls.forEach((ball) => {
      // Get ball components.
      const ballTransform = ball.getComponent(TransformData);
      const ballVelocity = ball.getMutableComponent(VelocityData);
      const ballMass = ball.getComponent(MassData);

      // For each fan...
      fans.forEach((fan) => {
        // Get fan components.
        const fanTransform = fan.getComponent(TransformData);
        const fanRotation = fan.getComponent(RotationData);

        // Calculate the vector from the fan to the ball.
        const dx = ballTransform.position.x - fanTransform.position.x;
        const dy = ballTransform.position.y - fanTransform.position.y;
        const distance = Math.sqrt(dx * dx + dy * dy);

        // If the ball is within 100 pixels of the fan...
        if (distance < 200) {
          // Calculate the angle between the fan and the ball.
          const angle = Math.atan2(dy, dx) - fanRotation.rotation;

          // Keep the angle between -PI and PI.
          const angle2 =
            angle - Math.PI * 2 * Math.floor((angle + Math.PI) / (Math.PI * 2));

          // Calculate the force of the fan on the ball.
          let force = 10 / distance;
          force = force / Math.abs(angle2);
          // Clamp the force to 100.
          force = Math.min(force, 100);

          // Apply the force to the ball's velocity.
          ballVelocity.velocity.x +=
            (force * Math.cos(fanRotation.rotation)) / ballMass.mass;
          ballVelocity.velocity.y +=
            (force * Math.sin(fanRotation.rotation)) / ballMass.mass;
        }
      });
    });
  }
}
